import React, {useContext} from "react"
import ButtonTemplate from "./ButtonTemplate"
import {WorkflowContext} from "../../../../src/context/WorkflowContextProvider"

const VARIANTS = {
    primary: "primary",
    secondary: "secondary",
    tertiary: "tertiary",
}

export const widgetWorkflowButtonPrototype = [
    {
        key: "variant",
        type: "SELECT",
        label: "Variante",
        size: 6,
        options: [
            {value: "primary", label: "Primär"},
            {value: "secondary", label: "Sekundär"},
            {value: "tertiary", label: "Tertiär"},
        ],
    },
    {
        key: "size",
        type: "SELECT",
        label: "Größe",
        size: 6,
        options: [
            {value: "medium", label: "Normal (100)"},
            {value: "small", label: "Klein (50)"},
        ],
    },
]

const WorkflowButtonWidget = ({widget, value, payload, triggerAction}) => {
    const {advance, getButtonConfig, hasTransition} = useContext(WorkflowContext)
    if (!hasTransition(widget.id)) {
        return null
    }
    const config = getButtonConfig(widget.id)
    const text = config.text ?? widget.text
    const variant = VARIANTS[config.variant ?? widget.variant] ?? "primary"
    const {size = "medium", error = false} = widget

    const handleClick = () => {
        if (widget.action) {
            triggerAction(widget.action, {widget, payload: payload ?? value})
        }
        advance(widget.id)
    }

    return (
        <ButtonTemplate
            color={error ? "error" : ""}
            size={size}
            buttonText={text}
            startIcon={widget.startIcon}
            endIcon={widget.endIcon}
            disabled={widget.disabled}
            widget={widget}
            variant={variant}
            onClick={handleClick}
        />
    )
}

export default WorkflowButtonWidget
